import {LoaderFunction, redirect} from 'react-router';
import {APP_PATH, PROFILE_PATH} from '@/constants/routes';
import {getProfile, UserProfile} from '@/repositories/beneva-api/endpoints/users';
import {hasCompleteUserProfile} from '@/utils/user-profile';

export const UnavailableLoader: LoaderFunction = async () => {
  // Retry to load the user profile, user might have been coming diretly to the unavailable page
  try {
    const profile = await getProfile();
    const userProfile: UserProfile = profile.data;

    if (!hasCompleteUserProfile(userProfile)) {
      return redirect(PROFILE_PATH);
    }

    return redirect(APP_PATH);
  } catch (_error) {
    // If it's still failing, we proceed to the unavailable page
    return null;
  }
};
